import { lazy } from "react";
import Loadable from "app/components/Loadable";

const AssetTypeList = Loadable(lazy(() => import("./AssetTypeList")));
const AssetTypeAdd = Loadable(lazy(() => import("./AssetTypeAdd")));

const AssetTypeRoutes = [
  { path: "/inv/asset-type", element: <AssetTypeList /> },
  { path: "/inv/asset-type/:mode/:id", element: <AssetTypeAdd /> },
];

export default AssetTypeRoutes;
